module.exports = __webpack_public_path__ + "static/media/DePasionesYRazones.40d84522.pdf";